import AMS from "./pos";

function App() {
  return <AMS />;
}

export default App;
